module.exports = __webpack_public_path__ + "media/images/favicon/primary/android-icon-36x36-486048b5f46bd0758947754b0b9dffc2.png";